import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Constanst } from '../core/constants/constans.component';
import { LocalStorageService } from '../core/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private localStorageService: LocalStorageService) { };

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let valid = false;
        let loginUser = this.localStorageService.getItem(Constanst.STORAGE_DATA_USER);
        let isLoggedIn = (loginUser != null && loginUser.trim().length > 0 ? true : false);
        if (isLoggedIn) {
            valid = true;
        } else {
            this.router.navigate(['/login']);
        }
        return valid;
    }
}
